import script from "./TodoListUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoListUpdate.vue?vue&type=script&setup=true&lang=js"

import "./TodoListUpdate.vue?vue&type=style&index=0&id=83248476&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83248476"]])

export default __exports__